const avatarColors = [
  [346, 92, 63],
  [0, 92, 63],
  [12, 92, 63],
  [15, 92, 63],
  [52, 92, 53],
  [83, 92, 63],
  [120, 92, 63],
  [189, 92, 63],
  [211, 92, 63],
  [246, 92, 63],
  [261, 92, 63],
  [289, 92, 63],
  [315, 92, 63],
  [326, 92, 63],
  [6, 92, 63],
  [14, 92, 63],
  [24, 92, 63],
  [63, 92, 53],
  [99, 92, 63],
  [170, 92, 63],
  [199, 92, 63],
  [230, 92, 63],
  [255, 92, 63],
  [274, 92, 63],
  [299, 92, 63],
  [335, 92, 63],
  [336, 92, 63],
  [346, 92, 63],
  [10, 92, 63],
  [30, 92, 63],
  [50, 92, 53],
  [70, 92, 53],
  [90, 92, 63],
  [110, 92, 63],
  [130, 92, 63],
  [150, 92, 63],
  [170, 92, 63],
  [190, 92, 63],
  [210, 92, 63],
  [230, 92, 63],
  [250, 92, 63],
  [270, 92, 63],
  [290, 92, 63],
  [310, 92, 63],
  [330, 92, 63],
  [350, 92, 63],
]

export function stringAsciiPRNG(value, m) {
  // Xn+1 = (a * Xn + c) % m
  // 0 < a < m
  // 0 <= c < m
  // 0 <= X0 < m

  if (!value) { return 0 }

  const charCodes = [...value].map((letter) => letter.charCodeAt(0))
  const len = charCodes.length

  const a = (len % (m - 1)) + 1
  const c = charCodes.reduce((current, next) => current + next) % m

  let random = charCodes[0] % m
  for (let i = 0; i < len; i++) {
    random = (a * random + c) % m
  }

  return random
}

function getRandomColorIndex(value, colors = avatarColors) {
  // if no value is passed, always return transparent color otherwise
  // a rerender would show a new color which would will
  // give strange effects when an interface is loading
  // and gets rerendered a few consequent times
  if (!value) {
    return 'transparent'
  }

  // value based random color index
  // the reason we don't just use a random number is to make sure that
  // a certain value will always get the same color assigned given
  // a fixed set of colors
  return stringAsciiPRNG(value, colors.length)
}

const generateColor = ([h, s, l], a = 100) => `hsl(${h}, ${s}%, ${l}%, ${a}%)`

export default function generateAvatarColors(value) {
  if (!value) value = 'Default'
  const colorIndex = getRandomColorIndex(value)

  const baseColor = avatarColors[colorIndex]
  const baseColor2 = avatarColors[(colorIndex + 1) % avatarColors.length]
  const baseColor3 = avatarColors[(colorIndex + 2) % avatarColors.length]

  return {
    baseColor: generateColor(baseColor),
    baseColor2: generateColor(baseColor2),
    baseColor3: generateColor(baseColor3),
  }
}
